import { RemoveCircle } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import log from 'loglevel';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { ACTION_MENU_TYPE } from '../../CandidateMatchesTable/consts';
import { ThumbsUp } from '../../../../icons/thumbs-up';
import { useAuth } from '../../../../hooks/useAuth';
import STRING_KEYS from '../../../../language/keys';
import { PERMISSIONS } from '../../../../consts/permissions';
import { MatchStatusEnum } from '../../../../consts/enums';
import { MatchesBulkPanelItems } from './MatchesBulkPanelItems';
import { style } from './style';

type MatchesBulkPanelProps = {
  counter: number,
  onResetSelectedIds: () => void,
  onAcceptClick: (status: MatchStatusEnum) => void,
}

const TAG = '[MATCH_BULK_EDIT]';

export const MatchesBulkPanel = ({
  counter,
  onResetSelectedIds,
  onAcceptClick,
}: MatchesBulkPanelProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const { hasPermissions } = useAuth();
  const defaultActions = [

    {
      title: STRING_KEYS.DRAFT,
      icon: <ThumbsUp />,
      type: ACTION_MENU_TYPE.ACCEPT_DRAFT,
      permissions: [PERMISSIONS.MATCH_EDIT],
      color: '#ffbf4c',
    },
    {
      title: STRING_KEYS.PUBLISH,
      icon: <ThumbsUp />,
      type: ACTION_MENU_TYPE.ACCEPT_PUBLISHED,
      permissions: [PERMISSIONS.MATCH_EDIT],
      color: '#14B8A6',
    },
  ];

  const actions = defaultActions.filter((action) => {
    return !action.permissions || hasPermissions(action.permissions);
  }).map((defaultAction) => {
    const title = translate(defaultAction.title);

    return {
      icon: defaultAction.icon,
      title,
      type: defaultAction.type,
      color: defaultAction.color,
    };
  });

  const handleActionMenu = (type:string) => {
    switch (type) {
      case ACTION_MENU_TYPE.ACCEPT_DRAFT:
        onAcceptClick(MatchStatusEnum.draft);
        break;
      case ACTION_MENU_TYPE.ACCEPT_PUBLISHED:
        onAcceptClick(MatchStatusEnum.published);
        break;
      default: {
        log.warn(TAG, 'No such type of action');
      }
    }
  };

  return (
    <Box sx={ style.box.sx }>
      <Box sx={ style.row.sx }>
        <Box sx={ style.flex.sx }>
          <IconButton onClick={ onResetSelectedIds }>
            <RemoveCircle />
          </IconButton>
          <Typography variant="body2" sx={ style.Typography.sx }>
            {counter}
            &nbsp;
            {counter === 1 ?
              translate(STRING_KEYS.MATCH_SELECTED) :
              translate(STRING_KEYS.MATCHES_SELECTED)}
          </Typography>
        </Box>
        <MatchesBulkPanelItems
          items={ actions }
          onActionClick={ handleActionMenu }
        />
      </Box>
    </Box>
  );
};
